import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import SendIcon from "@material-ui/icons/Send";
import MenuIcon from "@material-ui/icons/Menu";
import HomeIcon from "@material-ui/icons/Home";
import Assignment from "@material-ui/icons/Assignment";
import { withRouter } from "react-router-dom";

const styles = {
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  }
};

class AppDrawer extends Component {
  state = {
    left: false
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
        <List>
          <ListItem
            button
            onClick={e => this.props.history.push("/")}
            key={"Home"}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={"Home"} />
          </ListItem>
          <ListItem
            button
            onClick={e => this.props.history.push("/new")}
            key={"CWD Sample"}
          >
            <ListItemIcon>
              <Assignment />
            </ListItemIcon>
            <ListItemText primary={"CWD Sample"} />
          </ListItem>
        </List>
        <Divider />
        <List>
          <a
            style={{ marginLeft: 10 }}
            href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=SoftwareDevs@agfc.ar.gov"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <ListItem button link="true" key={"Contact Support"}>
              <ListItemIcon>
                <SendIcon />
              </ListItemIcon>
              <ListItemText primary={"Contact Support"} />
            </ListItem>
          </a>
        </List>
      </div>
    );

    return (
      <Fragment>
        <MenuIcon
          style={{ fontSize: 30 }}
          onClick={this.toggleDrawer("left", true)}
        />
        <Drawer
          open={this.state.left}
          onClose={this.toggleDrawer("left", false)}
        >
          <div
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer("left", false)}
            onKeyDown={this.toggleDrawer("left", false)}
          >
            {sideList}
          </div>
        </Drawer>
      </Fragment>
    );
  }
}

AppDrawer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withRouter(AppDrawer));



// WEBPACK FOOTER //
// ./src/components/drawer.jsx